import {AfterViewInit, Component, OnDestroy, ViewChild, ChangeDetectionStrategy, signal} from "@angular/core";
import {ModalComponent} from "../../shared/components/modal/modal.component";
import {Subject} from "rxjs";
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import {ApiRouterService, NotificationsService} from "@twino/core-lib";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  selector: 'netcard-modal-notifications',
  templateUrl: './modal-notifications.component.html',
})
export class ModalNotificationsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('updateDataModal') updateDataModal: ModalComponent;
  @ViewChild('applyForIncreaseAmount') applyForIncreaseAmountModal: ModalComponent;
  @ViewChild('limitIncreaseSuccess') limitIncreaseSuccessModal: ModalComponent;

  $unsubscribe = new Subject();

  modalNotificationsConfig;

  /**
   * Which modal bodies have been requested. A signal so the OnPush template re-renders under
   * zoneless change detection when a notification arrives from the api-router response.
   */
  initView = signal<Record<string, boolean>>({
    UPDATE_IDENTITY_DOCUMENT: false
  });

  constructor(private apiService: ApiRouterService, private notificationsService: NotificationsService) {
  }

  ngAfterViewInit() {
    this.modalNotificationsConfig = {
      UPDATE_IDENTITY_DOCUMENT : {modal: this.updateDataModal, markAsDelivered: false},
      // CREDIT_LIMIT_INCREASE_POSSIBILITY: {modal: this.applyForIncreaseAmountModal},
      // CREDIT_LIMIT_INCREASE_SUCCESS: { modal: this.limitIncreaseSuccessModal, markAsDelivered: true},
    };

    this.apiService.notifications$.pipe(
      filter(notifications => notifications.length > 0),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),  // Custom comparison if notifications are objects
      takeUntil(this.$unsubscribe)
    ).subscribe(notifications => this.showNotifications(notifications));

  }

  ngOnDestroy() {
    this.$unsubscribe.next();
  }

  showNotifications(notifications: { id: number, type: string }[]): void {
    notifications.forEach(notification => {
      this.initView.update(view => ({ ...view, [notification.type]: true }));
      const notificationConfig = this.modalNotificationsConfig[notification.type];

      if (notificationConfig?.modal?.openModal) {
        notificationConfig.modal.openModal();

        if (notificationConfig.markAsDelivered) {
          this.notificationsService.markAsDelivered(notification.id);
        }
      }
    });
  }

}
